// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Bravura.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  --background: #f4f4f4;
  --background-slightly-darker: #f9f9f9;
  --foreground: #000;
  --foreground-greyed: #aaa;
}
@media (prefers-color-scheme: dark) {
  body {
    --background: #252525;
    --background-slightly-darker: #444;
    --foreground: #fff;
    --foreground-greyed: #999;
  }
}
body {
  font-family: Arial, sans-serif;
  text-align: center;
  background-color: var(--background);
  color: var(--foreground);
  margin: 0;
}
* {
  touch-action: manipulation;
}
/* Footer */
body {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}
main {
  flex: 1;
}
footer {
  background-color: var(--background-off);
  border-top: 1px solid var(--background-off2);
  color: var(--foreground-greyed);
  font-size: 0.8em;
}
footer a {
  color: var(--foreground-greyed);
}
/* Header */
h1 {
  display: inline-block;
  line-height: 50px;
  vertical-align: middle;
}
/* Settings Menu */
#settings-cog,
#settings-close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px;
  cursor: pointer;
  color: var(--foreground-greyed);
  transition: color 0.2s;
}
#settings-cog:hover,
#settings-close:hover {
  color: var(--foreground);
}
#settings-cog::before {
  content: "\\2699";
  font-size: 40px;
}
#settings-close::before {
  content: "\\2715";
  font-size: 20px;
  top: 10px;
}
#settings-menu {
  display: none;
  position: absolute;
  max-width: 300px;
  z-index: 10;
  text-align: left;
  background-color: var(--background-slightly-darker);
  border: 1px solid var(--foreground-greyed);
  top: 0;
  right: 0;
  padding: 20px 40px;
  font-size: 20px;
}
#settings-menu.visible {
  display: block;
}
#settings-menu .setting:not(:last-child) {
  margin-bottom: 30px;
}
#settings-menu .setting p {
  font-size: 16px;
}
#settings-menu label {
  display: block;
  margin: 10px 0;
}
/* Circle of Fifths */
#circle-of-fifths {
  display: flex;
  align-items: center;
  --note-size: min(60px, 9vw);
  --note-padding: min(6px, 1vw);
  --note-distance: calc(var(--note-size) + var(--note-padding));
}
#circle-of-fifths .controls {
  flex-grow: 1;
  text-align: center;
  padding: 0 2px;
  z-index: 2;
}
#circle-of-fifths .controls button {
  display: block;
  margin: auto;
  background-color: transparent;
  border: none;
  color: var(--foreground-greyed);
  font-size: 14px;
  cursor: pointer;
  padding: 5px;
  transition: color 0.2s;
}
#circle-of-fifths .controls button:hover {
  color: var(--foreground);
}
#circle-of-fifths .controls button::before {
  font-size: 14px;
}
#circle-of-fifths .controls button.left::before {
  content: "\\25C0";
}
#circle-of-fifths .controls button.left.double::before {
  content: "\\25C0\\25C0";
  letter-spacing: -6px;
}
#circle-of-fifths .controls button.right::before {
  content: "\\25B6";
}
#circle-of-fifths .controls button.right.double::before {
  content: "\\25B6\\25B6";
  letter-spacing: -4px;
}
#circle-of-fifths .circle {
  white-space: nowrap;
  position: relative;
  width: calc((var(--note-size) * 7) + (var(--note-padding) * 6));
  height: var(--note-size);
}
#circle-of-fifths .circle .note {
  display: inline-block;
  width: var(--note-size);
  height: var(--note-size);
  line-height: var(--note-size);
  font-size: min(1.5em, 4vw);
  border-radius: 50%;
  background-color: var(--background-slightly-darker);
  border: 1px solid var(--foreground-greyed);
  opacity: 0;
  transition: all 200ms ease-in-out;
  position: absolute;
}
#circle-of-fifths .circle .note.in-scale {
  opacity: 1;
  cursor: pointer;
}
#circle-of-fifths .circle .note:not(.in-scale) {
  pointer-events: none;
}
#circle-of-fifths .circle .note.note-off-start {
  left: calc(-1 * var(--note-distance));
}
#circle-of-fifths .circle .note.note-1 {
  left: 0;
}
#circle-of-fifths .circle .note.note-2 {
  left: calc(1 * var(--note-distance));
}
#circle-of-fifths .circle .note.note-3 {
  left: calc(2 * var(--note-distance));
}
#circle-of-fifths .circle .note.note-4 {
  left: calc(3 * var(--note-distance));
}
#circle-of-fifths .circle .note.note-5 {
  left: calc(4 * var(--note-distance));
}
#circle-of-fifths .circle .note.note-6 {
  left: calc(5 * var(--note-distance));
}
#circle-of-fifths .circle .note.note-7 {
  left: calc(6 * var(--note-distance));
}
#circle-of-fifths .circle .note.note-off-end {
  left: calc(7 * var(--note-distance));
}
#circle-of-fifths .arrow-container {
  position: relative;
  width: calc((var(--note-size) * 7) + (var(--note-padding) * 6));
  height: 20px;
  padding-top: 10px;
}
#circle-of-fifths .arrow-container .arrow {
  position: absolute;
  font-size: 20px;
  transition: left 200ms ease-in-out;
  margin-left: calc((var(--note-size) / 2) - 10px);
}
#circle-of-fifths .arrow-container .arrow.up::before {
  content: "\\25B2";
}
#circle-of-fifths .arrow-container .arrow.lydian {
  left: 0;
}
#circle-of-fifths .arrow-container .arrow.ionian {
  left: calc(1 * var(--note-distance));
}
#circle-of-fifths .arrow-container .arrow.mixolydian {
  left: calc(2 * var(--note-distance));
}
#circle-of-fifths .arrow-container .arrow.dorian {
  left: calc(3 * var(--note-distance));
}
#circle-of-fifths .arrow-container .arrow.aeolian {
  left: calc(4 * var(--note-distance));
}
#circle-of-fifths .arrow-container .arrow.phrygian {
  left: calc(5 * var(--note-distance));
}
#circle-of-fifths .arrow-container .arrow.locrian {
  left: calc(6 * var(--note-distance));
}
/* Piano */
#piano {
  display: inline-block;
  margin: 20px 0;
  --key-size: min(1.3vw, 14px);
  position: relative;
}
#piano .key {
  border: 1px solid var(--foreground);
  display: inline-block;
  position: relative;
}
#piano .key.white-key {
  width: calc(4 * var(--key-size));
  height: calc(15 * var(--key-size));
  background-color: white;
  margin: 0 1px;
  z-index: 1;
}
#piano .key.black-key {
  width: calc(3 * var(--key-size));
  height: calc(10 * var(--key-size));
  background-color: black;
  margin-left: calc(-1.5 * var(--key-size));
  margin-right: calc(-1.5 * var(--key-size));
  z-index: 2;
  margin-bottom: calc(5 * var(--key-size));
}
#piano .key.active.white-key {
  background-color: #f44336 !important;
}
#piano .key.active.white-key.in-scale {
  background-color: #cee500 !important;
}
#piano .key.active.white-key.in-scale.in-next-chord {
  background-color: #a5d558 !important;
}
#piano .key.active.white-key.in-scale.in-chord {
  background-color: #54be58 !important;
}
#piano .key.active.black-key {
  background-color: #e71e10 !important;
}
#piano .key.active.black-key.in-scale {
  background-color: #a6cf12 !important;
}
#piano .key.active.black-key.in-scale.in-next-chord {
  background-color: #7fbf18 !important;
}
#piano .key.active.black-key.in-scale.in-chord {
  background-color: #16a81b !important;
}
#piano #dots {
  position: absolute;
  z-index: 2;
  pointer-events: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
#piano #dots .dot {
  position: absolute;
  width: 1vw;
  height: 1vw;
  margin: -0.8vw;
  border: 0.3vw solid;
  border-radius: 50%;
  transition: all 200ms ease-in-out;
}
#piano #dots .dot.root.natural {
  background: black;
}
#piano #dots .dot.root.sharp {
  background: white;
}
#piano #dots .dot.natural {
  top: 85%;
  border-color: black;
}
#piano #dots .dot.sharp {
  top: 51%;
  border-color: white;
}
#piano #dots .dot.dot-1.C.natural {
  left: 3.5%;
}
#piano #dots .dot.dot-1.C.sharp {
  left: 7%;
}
#piano #dots .dot.dot-1.D.natural {
  left: 10.5%;
}
#piano #dots .dot.dot-1.D.sharp {
  left: 14.3%;
}
#piano #dots .dot.dot-1.E.natural {
  left: 17.9%;
}
#piano #dots .dot.dot-1.F.natural {
  left: 24.8%;
}
#piano #dots .dot.dot-1.F.sharp {
  left: 28.4%;
}
#piano #dots .dot.dot-1.G.natural {
  left: 32%;
}
#piano #dots .dot.dot-1.G.sharp {
  left: 35.6%;
}
#piano #dots .dot.dot-1.A.natural {
  left: 39.1%;
}
#piano #dots .dot.dot-1.A.sharp {
  left: 42.9%;
}
#piano #dots .dot.dot-1.B.natural {
  left: 46.5%;
}
#piano #dots .dot.dot-2.C.natural {
  left: 53.7%;
}
#piano #dots .dot.dot-2.C.sharp {
  left: 57.1%;
}
#piano #dots .dot.dot-2.D.natural {
  left: 60.7%;
}
#piano #dots .dot.dot-2.D.sharp {
  left: 64.3%;
}
#piano #dots .dot.dot-2.E.natural {
  left: 68%;
}
#piano #dots .dot.dot-2.F.natural {
  left: 74.9%;
}
#piano #dots .dot.dot-2.F.sharp {
  left: 78.4%;
}
#piano #dots .dot.dot-2.G.natural {
  left: 82.1%;
}
#piano #dots .dot.dot-2.G.sharp {
  left: 85.7%;
}
#piano #dots .dot.dot-2.A.natural {
  left: 89.5%;
}
#piano #dots .dot.dot-2.A.sharp {
  left: 93%;
}
#piano #dots .dot.dot-2.B.natural {
  left: 96.6%;
}
#piano .numeral {
  position: absolute;
  bottom: 10px;
  width: 100%;
  text-align: center;
  font-size: min(0.8em, 2.5vw);
}
/* Chords */
#chords {
  margin-top: 20px;
  font-size: min(16px, 4vw);
}
/* Notation */
@font-face {
  font-family: 'Bravura';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}
#notation {
  display: inline-block;
  height: 200px;
  width: min(100%, 900px);
  position: relative;
  z-index: -1;
  margin-top: 15px;
}
#notation #sheet {
  position: absolute;
  width: 100%;
  height: 100px;
  top: 79px;
}
@media (max-width: 500px) {
  #notation #sheet {
    top: 101px;
  }
}
#notation #sheet .line {
  border-bottom: 2px solid var(--foreground-greyed);
  position: absolute;
  width: 100%;
  left: 0;
}
#notation #sheet .line.line-1 {
  top: 0%;
}
#notation #sheet .line.line-2 {
  top: 20%;
}
#notation #sheet .line.line-3 {
  top: 40%;
}
#notation #sheet .line.line-4 {
  top: 60%;
}
#notation #sheet .line.line-5 {
  top: 80%;
}
#notation #sheet .clef {
  font-family: 'Bravura', sans-serif;
  font-size: 70px;
  position: absolute;
  left: 0;
  top: -80px;
}
#notation #sheet #key-signature {
  font-family: 'Bravura', sans-serif;
  font-size: 70px;
  position: absolute;
  left: 50px;
  top: -90px;
}
#notation #sheet #key-signature .note {
  position: absolute;
}
#notation #sheet #key-signature .note.flat::after {
  content: "\\E260";
}
#notation #sheet #key-signature .note.sharp::after {
  content: "\\E262";
}
#notation #sheet #key-signature .note.G.sharp {
  top: -60px;
}
#notation #sheet #key-signature .note.F {
  top: -50px;
}
#notation #sheet #key-signature .note.E {
  top: -40px;
}
#notation #sheet #key-signature .note.D {
  top: -30px;
}
#notation #sheet #key-signature .note.C {
  top: -20px;
}
#notation #sheet #key-signature .note.B {
  top: -10px;
}
#notation #sheet #key-signature .note.A {
  top: 0px;
}
#notation #sheet #key-signature .note.G.flat {
  top: 10px;
}
#notation #sheet #key-signature .note.F.sharp {
  left: 0px;
}
#notation #sheet #key-signature .note.C.sharp {
  left: 15px;
}
#notation #sheet #key-signature .note.G.sharp {
  left: 30px;
}
#notation #sheet #key-signature .note.D.sharp {
  left: 45px;
}
#notation #sheet #key-signature .note.A.sharp {
  left: 60px;
}
#notation #sheet #key-signature .note.E.sharp {
  left: 75px;
}
#notation #sheet #key-signature .note.B.sharp {
  left: 90px;
}
#notation #sheet #key-signature .note.B.flat {
  left: 0px;
}
#notation #sheet #key-signature .note.E.flat {
  left: 15px;
}
#notation #sheet #key-signature .note.A.flat {
  left: 30px;
}
#notation #sheet #key-signature .note.D.flat {
  left: 45px;
}
#notation #sheet #key-signature .note.G.flat {
  left: 60px;
}
#notation #sheet #key-signature .note.C.flat {
  left: 75px;
}
#notation #sheet #key-signature .note.F.flat {
  left: 90px;
}
#notation #crotchets {
  white-space: nowrap;
  margin-top: 1px;
  margin-left: 130px;
  margin-right: 50px;
}
#notation #crotchets.contains-4 .chord {
  width: calc(100% / 4);
  font-size: 18px;
}
#notation #crotchets.contains-7 .chord {
  width: calc(100% / 7);
  font-size: 16px;
}
#notation #crotchets .chord {
  display: inline-block;
  font-weight: bold;
  color: var(--foreground-greyed);
  line-height: 22px;
}
#notation #crotchets .chord.active {
  color: black;
}
#notation #crotchets .chord .name {
  margin: 0 -10px;
}
#notation #crotchets .chord .name .spacer {
  display: inline-block;
}
@media (max-width: 500px) {
  #notation #crotchets .chord .name .spacer {
    display: block;
  }
}
#notation #crotchets .chord .numeral {
  font-size: 0.8em;
  margin: 5px 0 30px 0;
}
#notation #crotchets .crotchet {
  font-family: 'Bravura', sans-serif;
  font-size: 70px;
  display: inline-block;
  line-height: 20px;
  position: relative;
}
@media (max-width: 500px) {
  #notation #crotchets .crotchet {
    font-weight: normal;
  }
}
#notation #crotchets .crotchet.D {
  top: 40px;
}
#notation #crotchets .crotchet.E {
  top: 30px;
}
#notation #crotchets .crotchet.F {
  top: 20px;
}
#notation #crotchets .crotchet.G {
  top: 10px;
}
#notation #crotchets .crotchet.A {
  top: 0px;
}
#notation #crotchets .crotchet.B {
  top: -10px;
}
#notation #crotchets .crotchet.C {
  top: -20px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/styles.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,qCAAA;EACA,kBAAA;EACA,yBAAA;AACF;AAEA;EACE;IACI,qBAAA;IACA,kCAAA;IACA,kBAAA;IACA,yBAAA;EAAJ;AACF;AAGA;EACE,8BAAA;EACA,kBAAA;EACA,mCAAA;EACA,wBAAA;EACA,SAAA;AADF;AAIA;EACE,0BAAA;AAFF;AACA,WAAW;AAMX;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAJF;AAOA;EACE,OAAA;AALF;AAQA;EACE,uCAAA;EACA,4CAAA;EACA,+BAAA;EACA,gBAAA;AANF;AAEA;EAOI,+BAAA;AANJ;AACA,WAAW;AAWX;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;AATF;AACA,kBAAkB;AAalB;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;EACA,sBAAA;AAVF;AAYE;;EACE,wBAAA;AATJ;AAaA;EAAwB,gBAAA;EAAkB,eAAA;AAT1C;AAUA;EAA0B,gBAAA;EAAkB,eAAA;EAAiB,SAAA;AAL7D;AAOA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mDAAA;EACA,0CAAA;EACA,MAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AALF;AAOE;EACE,cAAA;AALJ;AASI;EACE,mBAAA;AAPN;AAZA;EAsBM,eAAA;AAPN;AAfA;EA2BI,cAAA;EACA,cAAA;AATJ;AACA,qBAAqB;AAcrB;EACE,aAAA;EACA,mBAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6DAAA;AAbF;AAOA;EASI,YAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AAbJ;AACA;EAeM,cAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAbN;AAeM;EACE,wBAAA;AAbR;AAgBM;EAAY,eAAA;AAblB;AAeM;EAAiB,gBAAA;AAZvB;AAaM;EAAwB,qBAAA;EAAwB,oBAAA;AATtD;AAUM;EAAkB,gBAAA;AAPxB;AAQM;EAAyB,qBAAA;EAAuB,oBAAA;AAJtD;AA9BA;EAuCI,mBAAA;EACA,kBAAA;EACA,+DAAA;EACA,wBAAA;AANJ;AApCA;EA6CM,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,0BAAA;EACA,kBAAA;EACA,mDAAA;EACA,0CAAA;EAEA,UAAA;EACA,iCAAA;EAKA,kBAAA;AAXN;AAQM;EAAa,UAAA;EAAY,eAAA;AAJ/B;AAKM;EAAmB,oBAAA;AAFzB;AAMM;EAAmB,qCAAA;AAHzB;AAIM;EAAW,OAAA;AADjB;AAEM;EAAW,oCAAA;AACjB;AAAM;EAAW,oCAAA;AAGjB;AAFM;EAAW,oCAAA;AAKjB;AAJM;EAAW,oCAAA;AAOjB;AANM;EAAW,oCAAA;AASjB;AARM;EAAW,oCAAA;AAWjB;AAVM;EAAiB,oCAAA;AAavB;AAnFA;EA2EI,kBAAA;EACA,+DAAA;EACA,YAAA;EACA,iBAAA;AAWJ;AAzFA;EAiFM,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,gDAAA;AAWN;AATM;EAAe,gBAAA;AAYrB;AAVM;EAAW,OAAA;AAajB;AAZM;EAAW,oCAAA;AAejB;AAdM;EAAe,oCAAA;AAiBrB;AAhBM;EAAW,oCAAA;AAmBjB;AAlBM;EAAY,oCAAA;AAqBlB;AApBM;EAAa,oCAAA;AAuBnB;AAtBM;EAAY,oCAAA;AAyBlB;AACA,UAAU;AAnBV;EACE,qBAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;AAqBF;AAzBA;EAOI,mCAAA;EACA,qBAAA;EACA,kBAAA;AAqBJ;AAlBI;EACE,gCAAA;EACA,kCAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;AAoBN;AAjBI;EACE,gCAAA;EACA,kCAAA;EACA,uBAAA;EACA,yCAAA;EACA,0CAAA;EACA,UAAA;EACA,wCAAA;AAmBN;AAfM;EAAc,oCAAA;AAkBpB;AAjBM;EAAuB,oCAAA;AAoB7B;AAnBM;EAAqC,oCAAA;AAsB3C;AArBM;EAAgC,oCAAA;AAwBtC;AAvBM;EAAc,oCAAA;AA0BpB;AAzBM;EAAuB,oCAAA;AA4B7B;AA3BM;EAAqC,oCAAA;AA8B3C;AA7BM;EAAgC,oCAAA;AAgCtC;AAtEA;EA2CI,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AA8BJ;AA/EA;EAoDM,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;AA8BN;AA5BM;EAAiB,iBAAA;AA+BvB;AA9BM;EAAe,iBAAA;AAiCrB;AA/BM;EAAY,QAAA;EAAU,mBAAA;AAmC5B;AAlCM;EAAU,QAAA;EAAU,mBAAA;AAsC1B;AApCM;EAAoB,UAAA;AAuC1B;AAtCM;EAAkB,QAAA;AAyCxB;AAxCM;EAAoB,WAAA;AA2C1B;AA1CM;EAAkB,WAAA;AA6CxB;AA5CM;EAAoB,WAAA;AA+C1B;AA9CM;EAAoB,WAAA;AAiD1B;AAhDM;EAAkB,WAAA;AAmDxB;AAlDM;EAAoB,SAAA;AAqD1B;AApDM;EAAkB,WAAA;AAuDxB;AAtDM;EAAoB,WAAA;AAyD1B;AAxDM;EAAkB,WAAA;AA2DxB;AA1DM;EAAoB,WAAA;AA6D1B;AA5DM;EAAoB,WAAA;AA+D1B;AA9DM;EAAkB,WAAA;AAiExB;AAhEM;EAAoB,WAAA;AAmE1B;AAlEM;EAAkB,WAAA;AAqExB;AApEM;EAAoB,SAAA;AAuE1B;AAtEM;EAAoB,WAAA;AAyE1B;AAxEM;EAAkB,WAAA;AA2ExB;AA1EM;EAAoB,WAAA;AA6E1B;AA5EM;EAAkB,WAAA;AA+ExB;AA9EM;EAAoB,WAAA;AAiF1B;AAhFM;EAAkB,SAAA;AAmFxB;AAlFM;EAAoB,WAAA;AAqF1B;AA9KA;EA8FI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AAmFJ;AACA,WAAW;AA7EX;EACE,gBAAA;EACA,yBAAA;AA+EF;AACA,aAAa;AA3Eb;EACE,sBAAA;EACA,+DAAA;AA6EF;AA1EA;EACE,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AA4EF;AAlFA;EASI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;AA4EJ;AAzEI;EAAA;IACE,UAAA;EA4EJ;AACF;AA7FA;EAoBM,iDAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;AA4EN;AA1EM;EAAW,OAAA;AA6EjB;AA5EM;EAAW,QAAA;AA+EjB;AA9EM;EAAW,QAAA;AAiFjB;AAhFM;EAAW,QAAA;AAmFjB;AAlFM;EAAW,QAAA;AAqFjB;AAlHA;EAiCM,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;AAoFN;AAzHA;EAyCM,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AAmFN;AAhIA;EAgDQ,kBAAA;AAmFR;AAjFQ;EAAgB,gBAAA;AAoFxB;AAnFQ;EAAiB,gBAAA;AAsFzB;AApFQ;EAAY,UAAA;AAuFpB;AAtFQ;EAAM,UAAA;AAyFd;AAxFQ;EAAM,UAAA;AA2Fd;AA1FQ;EAAM,UAAA;AA6Fd;AA5FQ;EAAM,UAAA;AA+Fd;AA9FQ;EAAM,UAAA;AAiGd;AAhGQ;EAAM,QAAA;AAmGd;AAlGQ;EAAW,SAAA;AAqGnB;AApGQ;EAAY,SAAA;AAuGpB;AAtGQ;EAAY,UAAA;AAyGpB;AAxGQ;EAAY,UAAA;AA2GpB;AA1GQ;EAAY,UAAA;AA6GpB;AA5GQ;EAAY,UAAA;AA+GpB;AA9GQ;EAAY,UAAA;AAiHpB;AAhHQ;EAAY,UAAA;AAmHpB;AAlHQ;EAAW,SAAA;AAqHnB;AApHQ;EAAW,UAAA;AAuHnB;AAtHQ;EAAW,UAAA;AAyHnB;AAxHQ;EAAW,UAAA;AA2HnB;AA1HQ;EAAW,UAAA;AA6HnB;AA5HQ;EAAW,UAAA;AA+HnB;AA9HQ;EAAW,UAAA;AAiInB;AA3MA;EAgFI,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AA8HJ;AA5HI;EACE,qBAAA;EACA,eAAA;AA8HN;AA3HI;EACE,qBAAA;EACA,eAAA;AA6HN;AAzNA;EAgGM,qBAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;AA4HN;AA1HM;EACE,YAAA;AA4HR;AAlOA;EA0GQ,eAAA;AA2HR;AArOA;EA6GU,qBAAA;AA2HV;AAxHQ;EAAA;IAEI,cAAA;EA0HV;AACF;AA7OA;EAwHQ,gBAAA;EACA,oBAAA;AAwHR;AAjPA;EA8HM,kCAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AAsHN;AApHM;EAAA;IACE,mBAAA;EAuHN;AACF;AArHM;EAAM,SAAA;AAwHZ;AAvHM;EAAM,SAAA;AA0HZ;AAzHM;EAAM,SAAA;AA4HZ;AA3HM;EAAM,SAAA;AA8HZ;AA7HM;EAAM,QAAA;AAgIZ;AA/HM;EAAM,UAAA;AAkIZ;AAjIM;EAAM,UAAA;AAoIZ","sourcesContent":["body {\n  --background: #f4f4f4;\n  --background-slightly-darker: #f9f9f9;\n  --foreground: #000;\n  --foreground-greyed: #aaa;\n}\n\n@media (prefers-color-scheme: dark) {\n  body {\n      --background: #252525;\n      --background-slightly-darker: #444;\n      --foreground: #fff;\n      --foreground-greyed: #999;\n  }\n}\n\nbody {\n  font-family: Arial, sans-serif;\n  text-align: center;\n  background-color: var(--background);\n  color: var(--foreground);\n  margin: 0;\n}\n\n* {\n  touch-action: manipulation;\n}\n\n/* Footer */\n\nbody {\n  display: flex;\n  flex-direction: column;\n  min-height: 100dvh;\n}\n\nmain {\n  flex: 1;\n}\n\nfooter {\n  background-color: var(--background-off);\n  border-top: 1px solid var(--background-off2);\n  color: var(--foreground-greyed);\n  font-size: 0.8em;\n\n  a {\n    color: var(--foreground-greyed);\n  }\n}\n\n/* Header */\n\nh1 {\n  display: inline-block;\n  line-height: 50px;\n  vertical-align: middle;\n}\n\n/* Settings Menu */\n\n#settings-cog, #settings-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  cursor: pointer;\n  color: var(--foreground-greyed);\n  transition: color 0.2s;\n\n  &:hover {\n    color: var(--foreground);\n  }\n}\n\n#settings-cog::before { content: \"\\2699\"; font-size: 40px; }\n#settings-close::before { content: \"\\2715\"; font-size: 20px; top: 10px; }\n\n#settings-menu {\n  display: none;\n  position: absolute;\n  max-width: 300px;\n  z-index: 10;\n  text-align: left;\n  background-color: var(--background-slightly-darker);\n  border: 1px solid var(--foreground-greyed);\n  top: 0;\n  right: 0;\n  padding: 20px 40px;\n  font-size: 20px;\n\n  &.visible {\n    display: block;\n  }\n\n  .setting {\n    &:not(:last-child) {\n      margin-bottom: 30px;\n    }\n    p {\n      font-size: 16px;\n    }\n  }\n\n  label {\n    display: block;\n    margin: 10px 0;\n  }\n}\n\n/* Circle of Fifths */\n\n#circle-of-fifths {\n  display: flex;\n  align-items: center;\n\n  --note-size: min(60px, 9vw);\n  --note-padding: min(6px, 1vw);\n  --note-distance: calc(var(--note-size) + var(--note-padding));\n\n  .controls {\n    flex-grow: 1;\n    text-align: center;\n    padding: 0 2px;\n    z-index: 2;\n\n    button {\n      display: block;\n      margin: auto;\n      background-color: transparent;\n      border: none;\n      color: var(--foreground-greyed);\n      font-size: 14px;\n      cursor: pointer;\n      padding: 5px;\n      transition: color 0.2s;\n    \n      &:hover {\n        color: var(--foreground);\n      }\n    \n      &::before { font-size: 14px; }\n    \n      &.left::before { content: \"\\25C0\"; }\n      &.left.double::before { content: \"\\25C0\\25C0\";  letter-spacing: -6px; }\n      &.right::before { content: \"\\25B6\"; }\n      &.right.double::before { content: \"\\25B6\\25B6\"; letter-spacing: -4px; }\n    }\n  }\n\n  .circle {\n    white-space: nowrap;\n    position: relative;\n    width: calc((var(--note-size) * 7) + (var(--note-padding) * 6));\n    height: var(--note-size);\n\n    .note {\n      display: inline-block; \n      width: var(--note-size);\n      height: var(--note-size);\n      line-height: var(--note-size);\n      font-size: min(1.5em, 4vw);\n      border-radius: 50%;\n      background-color: var(--background-slightly-darker);\n      border: 1px solid var(--foreground-greyed);\n\n      opacity: 0;\n      transition: all 200ms ease-in-out;\n\n      &.in-scale { opacity: 1; cursor: pointer; }\n      &:not(.in-scale) { pointer-events: none; }\n\n      position: absolute;\n      \n      &.note-off-start { left: calc(-1 * var(--note-distance)); }\n      &.note-1 { left: 0; }\n      &.note-2 { left: calc(1 * var(--note-distance)); }\n      &.note-3 { left: calc(2 * var(--note-distance)); }\n      &.note-4 { left: calc(3 * var(--note-distance)); }\n      &.note-5 { left: calc(4 * var(--note-distance)); }\n      &.note-6 { left: calc(5 * var(--note-distance)); }\n      &.note-7 { left: calc(6 * var(--note-distance)); }\n      &.note-off-end { left: calc(7 * var(--note-distance)); }\n    }\n  }\n\n  .arrow-container {\n    position: relative;\n    width: calc((var(--note-size) * 7) + (var(--note-padding) * 6));\n    height: 20px;\n    padding-top: 10px;\n\n    .arrow {\n      position: absolute;\n      font-size: 20px;\n      transition: left 200ms ease-in-out;\n      margin-left: calc((var(--note-size) / 2) - 10px);\n\n      &.up::before { content: \"\\25B2\"; }\n\n      &.lydian { left: 0; }\n      &.ionian { left: calc(1 * var(--note-distance)); }\n      &.mixolydian { left: calc(2 * var(--note-distance)); }\n      &.dorian { left: calc(3 * var(--note-distance)); }\n      &.aeolian { left: calc(4 * var(--note-distance)); }\n      &.phrygian { left: calc(5 * var(--note-distance)); }\n      &.locrian { left: calc(6 * var(--note-distance)); }\n    }\n  }\n}\n\n/* Piano */\n\n#piano {\n  display: inline-block;\n  margin: 20px 0;\n  --key-size: min(1.3vw, 14px);\n  position: relative;\n\n  .key {\n    border: 1px solid var(--foreground);\n    display: inline-block;\n    position: relative;\n\n\n    &.white-key {\n      width: calc(4 * var(--key-size));\n      height: calc(15 * var(--key-size));\n      background-color: white;\n      margin: 0 1px;\n      z-index: 1;\n    }\n\n    &.black-key {\n      width: calc(3 * var(--key-size));\n      height: calc(10 * var(--key-size));\n      background-color: black;\n      margin-left: calc(-1.5 * var(--key-size));\n      margin-right: calc(-1.5 * var(--key-size));\n      z-index: 2;\n      margin-bottom: calc(5 * var(--key-size));\n    }\n\n    &.active {\n      &.white-key { background-color: #f44336 !important; }\n      &.white-key.in-scale { background-color: #cee500 !important; }\n      &.white-key.in-scale.in-next-chord { background-color: #a5d558 !important; }\n      &.white-key.in-scale.in-chord { background-color: #54be58 !important; }\n      &.black-key { background-color: #e71e10 !important; }\n      &.black-key.in-scale { background-color: #a6cf12 !important; }\n      &.black-key.in-scale.in-next-chord { background-color: #7fbf18 !important; }\n      &.black-key.in-scale.in-chord { background-color: #16a81b !important; }\n    }\n  }\n\n  #dots {\n    position: absolute;\n    z-index: 2;\n    pointer-events: none;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    .dot {\n      position: absolute;\n      width: 1vw;\n      height: 1vw;\n      margin: -0.8vw;\n      border: 0.3vw solid;\n      border-radius: 50%;\n      transition: all 200ms ease-in-out;\n\n      &.root.natural { background: black; }\n      &.root.sharp { background: white; }\n\n      &.natural { top: 85%; border-color: black; }\n      &.sharp { top: 51%; border-color: white; }\n\n      &.dot-1.C.natural { left: 3.5%; }\n      &.dot-1.C.sharp { left: 7.0%; }\n      &.dot-1.D.natural { left: 10.5%; }\n      &.dot-1.D.sharp { left: 14.3%; }\n      &.dot-1.E.natural { left: 17.9%; }\n      &.dot-1.F.natural { left: 24.8%; }\n      &.dot-1.F.sharp { left: 28.4%; }\n      &.dot-1.G.natural { left: 32.0%; }\n      &.dot-1.G.sharp { left: 35.6%; }\n      &.dot-1.A.natural { left: 39.1%; }\n      &.dot-1.A.sharp { left: 42.9%; }\n      &.dot-1.B.natural { left: 46.5%; }\n      &.dot-2.C.natural { left: 53.7%; }\n      &.dot-2.C.sharp { left: 57.1%; }\n      &.dot-2.D.natural { left: 60.7%; }\n      &.dot-2.D.sharp { left: 64.3%; }\n      &.dot-2.E.natural { left: 68.0%; }\n      &.dot-2.F.natural { left: 74.9%; }\n      &.dot-2.F.sharp { left: 78.4%; }\n      &.dot-2.G.natural { left: 82.1%; }\n      &.dot-2.G.sharp { left: 85.7%; }\n      &.dot-2.A.natural { left: 89.5%; }\n      &.dot-2.A.sharp { left: 93.0%; }\n      &.dot-2.B.natural { left: 96.6%; }\n    }\n  }\n\n  .numeral {\n    position: absolute;\n    bottom: 10px;\n    width: 100%;\n    text-align: center;\n    font-size: min(0.8em, 2.5vw);\n  }\n}\n\n/* Chords */\n\n\n#chords {\n  margin-top: 20px;\n  font-size: min(16px, 4vw);\n}\n\n/* Notation */\n\n@font-face {\n  font-family: 'Bravura';\n  src: url('Bravura.otf') format('opentype');\n}\n\n#notation {\n  display: inline-block;\n  height: 200px;\n  width: min(100%, 900px);\n  position: relative;\n  z-index: -1;\n  margin-top: 15px;\n\n  #sheet {\n    position: absolute;\n    width: 100%;\n    height: 100px;\n    top: 79px;\n\n    \n    @media (max-width: 500px) {\n      top: 101px;\n    }\n\n    .line {\n      border-bottom: 2px solid var(--foreground-greyed);\n      position: absolute;\n      width: 100%;\n      left: 0;\n\n      &.line-1 { top: 0%; }\n      &.line-2 { top: 20%; }\n      &.line-3 { top: 40%; }\n      &.line-4 { top: 60%; }\n      &.line-5 { top: 80%; }\n    }\n\n    .clef {\n      font-family: 'Bravura', sans-serif;\n      font-size: 70px;\n      position: absolute;\n      left: 0;\n      top: -80px;\n    }\n\n    #key-signature {\n      font-family: 'Bravura', sans-serif;\n      font-size: 70px;\n      position: absolute;\n      left: 50px;\n      top: -90px;\n\n      .note {\n        position: absolute;\n\n        &.flat::after { content: \"\\E260\"; }\n        &.sharp::after { content: \"\\E262\"; }\n\n        &.G.sharp { top: -60px; }\n        &.F { top: -50px; }\n        &.E { top: -40px; }\n        &.D { top: -30px; }\n        &.C { top: -20px; }\n        &.B { top: -10px; }\n        &.A { top: 0px; }\n        &.G.flat { top: 10px; }\n        &.F.sharp { left: 0px; }\n        &.C.sharp { left: 15px; }\n        &.G.sharp { left: 30px; }\n        &.D.sharp { left: 45px; }\n        &.A.sharp { left: 60px; }\n        &.E.sharp { left: 75px; }\n        &.B.sharp { left: 90px; }\n        &.B.flat { left: 0px; }\n        &.E.flat { left: 15px; }\n        &.A.flat { left: 30px; }\n        &.D.flat { left: 45px; }\n        &.G.flat { left: 60px; }\n        &.C.flat { left: 75px; }\n        &.F.flat { left: 90px; }\n      }\n    }\n  }\n\n  #crotchets {\n    white-space: nowrap;\n    margin-top: 1px;\n    margin-left: 130px;\n    margin-right: 50px;\n\n    &.contains-4 .chord {\n      width: calc((100%) / 4);\n      font-size: 18px;\n    }\n\n    &.contains-7 .chord {\n      width: calc((100%) / 7);\n      font-size: 16px;\n    }\n\n    .chord {\n      display: inline-block;\n      font-weight: bold;\n      color: var(--foreground-greyed);\n      line-height: 22px;\n\n      &.active {\n        color: black;\n      }\n    \n      .name {\n        margin: 0 -10px;\n\n        .spacer {\n          display: inline-block;\n        }\n\n        @media (max-width: 500px) {\n          .spacer {\n            display: block;\n          }\n        }\n      }\n\n      .numeral {\n        font-size: 0.8em;\n        margin: 5px 0 30px 0;\n      }\n    }\n\n    .crotchet {\n      font-family: 'Bravura', sans-serif;\n      font-size: 70px;\n      display: inline-block;\n      line-height: 20px;\n      position: relative;\n\n      @media (max-width: 500px) {\n        font-weight: normal;\n      }\n\n      &.D { top: 40px; }\n      &.E { top: 30px; }\n      &.F { top: 20px; }\n      &.G { top: 10px; }\n      &.A { top: 0px; }\n      &.B { top: -10px; }\n      &.C { top: -20px; }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
